import type { Field } from '@/types/field';

const SQM_PER_HA = 10000;

/**
 * 圃場の面積（m²）を ha 単位の数値に換算する。
 *
 * Field.area は m²（平方メートル）で格納されているため、10,000 で除算して ha に換算する。
 * 丸め処理は行わない（表示時に呼び出し側で必要な精度に整形すること）。
 *
 * @param field - 面積を換算する圃場
 * @returns ha 単位の数値（例: 0.3500554786...）
 */
export function fieldAreaInHa(field: Field): number {
  return field.area / SQM_PER_HA;
}

/**
 * 圃場の面積を ha 単位の表示文字列に変換する。
 *
 * 小数点2桁で整形し、末尾に "ha" を付加する。
 *
 * @param field - 面積を表示する圃場
 * @returns "X.XXha" 形式の文字列（例: "0.35ha"）
 */
export function formatFieldArea(field: Field): string {
  return `${fieldAreaInHa(field).toFixed(2)}ha`;
}
